module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.popen == 1) ? _c('p', {
    staticClass: "org-p1"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clicktransfer
    }
  }, [_vm._v("移交申报单位")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.clickdelect
    }
  }, [_vm._v("删除申报单位")])], 1) : _vm._e(), _vm._v(" "), (_vm.popen == 2) ? _c('p', {
    staticClass: "org-p1"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.Signout
    }
  }, [_vm._v("退出申报单位")])], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "移交申报单位",
      "visible": _vm.dialogtransfer,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogtransfer = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', [_c('realSearch', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.phone,
      "placeholder": "填写成员的手机号账号"
    },
    on: {
      "change": _vm.saveTel
    }
  })], 1)], 1), _vm._v(" "), _c('p', [_vm._v("移交后你将失去管理的权限, 确定移交？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogtransfer = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.transfer
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "退出申报单位",
      "visible": _vm.dialogclose,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogclose = $event
      }
    }
  }, [_c('p', {
    staticClass: "p-color1"
  }, [_vm._v("退出后将失去成员权限,确定退出？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogclose = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "删除申报单位",
      "visible": _vm.dialogdelect,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogdelect = $event
      }
    }
  }, [_c('p', {
    staticClass: "p-color1"
  }, [_vm._v("删除后将无法撤销,确认删除？")]), _vm._v(" "), _c('p', {
    staticClass: "p-color2"
  }, [_vm._v("当前申报单位若有关联的备案,则无法删除,如果需要退出,可以先移交给其他成员,再退出。")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogdelect = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.delect
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9734531c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/unit/setup.vue
// module id = 1269
// module chunks = 2